// ---------------------------------------------------------------
// useSwaps.js — Solicitudes de intercambio que me afectan (y las
// pendientes de aprobación si soy admin), en tiempo real.
// ---------------------------------------------------------------
import { useEffect, useState } from "react";
import { subscribeSwaps } from "../services/swapService";

export function useSwaps(uid, isAdmin) {
  const [swaps, setSwaps] = useState([]);

  useEffect(() => {
    if (!uid) return undefined;
    const unsubscribe = subscribeSwaps(
      uid,
      !!isAdmin,
      setSwaps,
      (error) => console.error("Error leyendo intercambios:", error)
    );
    return unsubscribe;
  }, [uid, isAdmin]);

  return swaps;
}
